import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import {RED} from 'ui-library/Colors';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Popover from 'ui-library/floating-ui/Popover';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {ProcedureValidationContext} from '../validation/ProcedureValidationContext';
import {ProcedureValidationError, ProcedureValidationObject} from '../validation/ProcedureValidationTypes';
import {
  buildTooltipFromErrors,
  findRelevantProcedureValidationErrors,
} from '../validation/procedureValidationUtils';

interface InfoButtonFromPreFilteredErrorsProps {
  preFilteredValidationErrors: Array<ProcedureValidationError>;
  primaryObject?: never;
}

interface InfoButtonFromPrimaryObjectProps {
  primaryObject: ProcedureValidationObject;
  preFilteredValidationErrors?: never;
}

type ProcedureValidationErrorInfoButtonProps =
  | InfoButtonFromPreFilteredErrorsProps
  | InfoButtonFromPrimaryObjectProps;

export default function ProcedureValidationErrorInfoButton(
  props: ProcedureValidationErrorInfoButtonProps
): JSX.Element {
  const {procedureValidationErrors} = ProcedureValidationContext.useContext();

  const tooltip =
    props.primaryObject != null
      ? buildTooltipFromErrors(
          findRelevantProcedureValidationErrors(procedureValidationErrors, props.primaryObject)
        )
      : buildTooltipFromErrors(props.preFilteredValidationErrors);

  return tooltip != null ? (
    <Popover
      placement={FloatingPlacement.TOP}
      renderContent={() => <div className={css(styles.validationErrorTooltip)}>{tooltip}</div>}
      {...getTestProps({component: 'ProcedureValidationErrorInfoButton', element: 'root'})}
    >
      <BenchlingIcon className={css(styles.validationErrorIcon)} icon="exclamation-circle" />
    </Popover>
  ) : (
    <></>
  );
}

const styles = StyleSheet.create({
  validationErrorIcon: {
    color: RED,
    width: '15px',
    height: '15px',
    marginRight: '8px',
    display: 'flex',
  },
  validationErrorTooltip: {
    lineHeight: '14px',
    whiteSpace: 'pre-line',
    textAlign: 'center',
    maxWidth: '170px',
  },
});
